import { useEffect, useState } from 'react'
import { TooltipContainer } from '../TooltipContainer'

export const VisualisationTooltip = ({
  className,
  width,
  height,
  toggleTreemapTooltip,
  tooltipState,
}) => {
  const [active, setActive] = useState(false)

  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown)
    document.addEventListener('mouseover', mouseOverHandler)

    return () => {
      document.removeEventListener('keydown', handleKeyDown)
      document.removeEventListener('mouseover', mouseOverHandler)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleShowTooltip = () => {
    try {
      if (unmounted) return

      setActive(true)
    } catch (err) {
      console.error(err)
    }
  }

  /** single source of the data */
  const mouseOverHandler = e => {
    if (
      e.target.matches(`.TreeMapsRenderer`) ||
      e.target.closest(`.TreeMapsRenderer`)
    ) {
      handleShowTooltip(0, '' /* index, type*/)
    }
  }

  const handleKeyDown = event => {
    if (event.key === 'Escape' || event.keyCode === 27 || event.which === 27) {
      toggleTreemapTooltip({ disable: true })
    }
  }

  return (
    <section
      className={className}
      style={{
        width,
        height,
        zIndex: 3,
      }}
    >
      <TooltipContainer
        active={active}
        targets={['TODO'] /* targets */}
        isVisible={tooltipState}
      />
    </section>
  )
}
